import { render, staticRenderFns } from "./CurrencyFormat.vue?vue&type=template&id=34b495b4&scoped=true"
import script from "./CurrencyFormat.vue?vue&type=script&lang=js"
export * from "./CurrencyFormat.vue?vue&type=script&lang=js"
import style0 from "./CurrencyFormat.vue?vue&type=style&index=0&id=34b495b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b495b4",
  null
  
)

export default component.exports